import * as t from "io-ts";

/**
 * How a phone verification code is delivered. Both prove ownership of the
 * same number; they differ only in delivery.
 */
export const PhoneVerificationChannel = t.keyof({
    sms: null,
    voice: null,
});
export type PhoneVerificationChannel = t.TypeOf<
    typeof PhoneVerificationChannel
>;

/**
 * Response from the phone verification send endpoint. Mirrors the email send
 * statuses: a code was sent, the number is already verified, or verification
 * isn't required (staff / CSRs).
 */
export const PhoneVerificationSendStatus = t.keyof({
    "sent": null,
    "already-verified": null,
    "not-required": null,
});
export type PhoneVerificationSendStatus = t.TypeOf<
    typeof PhoneVerificationSendStatus
>;

export const PhoneVerificationSendResponse = t.readonly(
    t.type({
        status: PhoneVerificationSendStatus,
    }),
);
export type PhoneVerificationSendResponse = t.TypeOf<
    typeof PhoneVerificationSendResponse
>;

export const PhoneVerificationVerifyResponse = t.readonly(
    t.type({
        status: t.literal("verified"),
    }),
);
export type PhoneVerificationVerifyResponse = t.TypeOf<
    typeof PhoneVerificationVerifyResponse
>;
